<template>
  <div class="oder">
    <user-info :userInfo="userInfo" :isShowFansBar="false" />
    <div class="content-bg">
      <h3>我的订单（{{ oderCount }}）</h3>
      <div class="oder-bg">
        <div class="goods">
          <van-image
            class="goods-img van-hairline--surround"
            :src="detailInfo.gift.image"
            fit="contain"
          />
          <div class="info">
            <div class="goods-name">{{ detailInfo.gift.name }}</div>
          </div>
        </div>
        <div class="address">
          <div class="title">邮寄地址</div>
          <span class="name">收件人：{{ detailInfo.name }}</span>
          <span class="phone">手机号：{{ detailInfo.phone }}</span>
          <p>
            {{
              detailInfo.province +
              detailInfo.city +
              detailInfo.county +
              detailInfo.address
            }}
          </p>
        </div>
        <div class="status">
          <span>订单状态：</span>
          <span>{{ isStatus(detailInfo.status) }}</span>
        </div>
        <div class="logistics">
          <span>物流信息：</span>
          <span>{{
            detailInfo.tracking_number ? detailInfo.tracking_number : "暂无"
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import UserInfo from "./child/UserInfo";
import AttentItem from "./child/AttentItem";
import CollectItem from "./child/CollectItem";
import { getRedeemedGiftDetail } from "network/profile";

export default {
  name: "Attent",
  components: {
    UserInfo,
    AttentItem,
    CollectItem,
  },
  data() {
    return {
      userInfo: {},
      detailInfo: {},
      oderCount: 0,
      currentIndex: 0,
    };
  },
  computed: {
    isStatus() {
      return (status) => {
        if (status === 1) {
          return "处理中...";
        } else {
          return "已发货";
        }
      };
    },
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.oderCount = this.$route.query.params.oderCount;
    this.getRedeemedGiftDetail();
  },
  mounted() {},
  methods: {
    //详情
    getRedeemedGiftDetail() {
      getRedeemedGiftDetail(this.$route.query.params.id).then((res) => {
        this.detailInfo = res.data;
      });
    },
  },
};
</script>
<style scoped>
.oder {
  background: #f5f5f5;
  min-height: 100vh;
}
.content-bg {
  margin: 20px 15px 0px 15px;
  padding: 10px;
  border-radius: 10px;
  background-color: #fff;
}
.content-bg h3 {
  font-size: 14px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e5e5e5;
}
.oder-bg {
  display: flex;
  flex-direction: column;
  align-content: space-around;
  min-height: 270px;
}
.goods {
  margin-top: 10px;
  padding-bottom: 20px;
  display: flex;
  border-bottom: 1px solid #e5e5e5;
}
.goods-img {
  width: 140px;
  height: 100px;
}
.info {
  margin-left: 5px;
}
.goods-name {
  margin-bottom: 3px;
  font-weight: 600;
  font-size: 14px;
}
.title {
  font-size: 14px;
  font-weight: 500;
}
.address {
  padding: 10px 0;
  border-bottom: 1px solid #e5e5e5;
}
.name {
  margin-right: 15px;
  font-size: 14px;
  font-weight: normal;
}
.phone {
  font-size: 14px;
  font-weight: normal;
}
.address p {
  font-size: 14px;
  font-weight: normal;
}
.status {
  padding: 10px 0;
  font-size: 14px;
  border-bottom: 1px solid #e5e5e5;
}
.status :nth-child(1) {
  font-weight: 500;
}
.logistics {
  margin-bottom: 30px;
  padding: 10px 0;
  font-size: 14px;
  border-bottom: 1px solid #e5e5e5;
}
.logistics :nth-child(1) {
  font-weight: 500;
}
</style>